function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 1.262c1.869 0 2.091.006 2.829.04 1.897.087 2.782.987 2.87 2.87.033.738.04.959.04 2.828 0 1.869-.007 2.091-.04 2.829-.088 1.882-.971 2.784-2.87 2.87-.738.034-.959.041-2.829.041-1.869 0-2.091-.008-2.828-.041-1.903-.087-2.783-.991-2.87-2.87-.033-.739-.041-.96-.041-2.829 0-1.869.008-2.09.041-2.828.087-1.884.971-2.783 2.87-2.87.738-.033.959-.04 2.828-.04zM3.405 7a3.595 3.595 0 107.19 0 3.595 3.595 0 00-7.19 0zm6.492-3.736a.84.84 0 101.68 0 .84.84 0 00-1.68 0zM7 9.333a2.333 2.333 0 100-4.666 2.333 2.333 0 000 4.666zm2.887 4.625c2.539-.117 3.956-1.527 4.071-4.072C13.992 9.14 14 8.901 14 7c0-1.901-.008-2.139-.042-2.886C13.844 1.575 12.432.16 9.887.043 9.14.008 8.901 0 7 0S4.861.008 4.114.043C1.571.159.159 1.57.042 4.114.008 4.861 0 5.099 0 7c0 1.901.008 2.14.042 2.886.117 2.543 1.528 3.955 4.072 4.072.747.034.985.042 2.886.042 1.901 0 2.14-.008 2.887-.042z",
  fill: "currentColor"
});

var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};

export default SvgSocialInstagram;